<div class="dashboard">
  <app-projects-review></app-projects-review>
</div>